module.exports = __webpack_public_path__ + "img/ekyc-sbank-guide-01.3073f025.png";